import { render, staticRenderFns } from "./DocumentsListView.vue?vue&type=template&id=2ea18af6&"
import script from "./DocumentsListView.vue?vue&type=script&lang=js&"
export * from "./DocumentsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports